// Codes of the one-time legacy collection migration (collectionMigration.ts).
// Not user-facing text: kept in a *.codes.ts file, which the literal guard
// (eslint.i18n.config.js) skips by design.

/**
 * localStorage key recording WHEN the migration copied the legacy blob on this
 * device (an ISO timestamp). Its presence alone means "migrated": the new code
 * never reads the legacy key again.
 */
export const COLLECTION_MIGRATED_AT_KEY = 'cb.collection.v2.migratedAt'

/** How long the untouched legacy blob is kept, so a reverted deploy still finds it. */
export const LEGACY_RETENTION_MS = 30 * 24 * 60 * 60 * 1000

/**
 * The pre-v2 claim-on-login markers. The new code never reads or writes them;
 * they are kept for a revert, and deleted with the legacy blob after the
 * retention window.
 */
export const LEGACY_CLAIM_MARKER_KEYS = [
  'commander-bracket-collection-claimed',
  'commander-bracket-collection-pending-sync',
] as const

export const MIGRATION = {
  /** This run copied the legacy blob into a scoped key: reload the active scope. */
  migrated: 'migrated',
  /** Nothing to do: done before, or there was no legacy blob. */
  done: 'done',
  /** Could not finish (unknown session, failed read, storage refused): next load retries. */
  retry: 'retry',
} as const

export type MigrationResult = typeof MIGRATION[keyof typeof MIGRATION]

/** Outcomes of a durable, conditional collection-record removal (collectionCache.removeCollectionRecordDurable). */
export const DURABLE_REMOVAL = { removed: 'removed', replaced: 'replaced', failed: 'failed' } as const
export type DurableRemoval = (typeof DURABLE_REMOVAL)[keyof typeof DURABLE_REMOVAL]

/** ownerStorage.readDurable's "can not tell". */
export const UNKNOWN_READ = 'unknown' as const

